import { render } from "./ViewSupplier.vue?vue&type=template&id=2e2f173c&scoped=true"
import script from "./ViewSupplier.vue?vue&type=script&lang=js"
export * from "./ViewSupplier.vue?vue&type=script&lang=js"

import "./ViewSupplier.vue?vue&type=style&index=0&id=2e2f173c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e2f173c"]])

export default __exports__